<div
    class="full-modal-config__section http-health-monitor-config"
    provideParentForm
>
     <h3>{{ healthMonitorTypesHash[editable.getType()] | vtranslate }}</h3>

    <health-monitor-port-ip-group [editable]="editable"></health-monitor-port-ip-group>

    <health-monitor-authentication [editable]="editable"></health-monitor-authentication>

    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.clientRequestHeaderInputLabel | vtranslate }}</h6>
            <ng-container *ngIf="!isHttp2Types">
                <newline-converted-textarea
                    name="http-request"
                    objectType="{{ objectTypes.HealthMonitorHttp }}"
                    fieldName="http_request"
                    [(ngModel)]="httpConfigItem.config.http_request"
                    placeholder="{{ l10nKeys.clientRequestHeaderInputPlaceholder | vtranslate }}"
                ></newline-converted-textarea>
            </ng-container>

            <ng-container *ngIf="isHttp2Types">
                <label
                    aviLabelWithTooltip
                    objectType="{{ objectTypes.HealthMonitorHttp }}"
                    fieldName="http_method"
                    for="http-method"
                >
                    {{ globalL10nKeys.httpMethodLabel | vtranslate }}
                </label>
                <avi-enum-dropdown
                    name="http-method"
                    id="http-method"
                    enum="HTTPMethod"
                    [hiddenEnumValues]="hiddenHttpMethodEnums"
                    [(ngModel)]="httpConfigItem.config.http_method"
                    placeholder="{{ l10nKeys.selectHttpMethodLabel | vtranslate }}"
                ></avi-enum-dropdown>
                <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        objectType="{{ objectTypes.HealthMonitorHttp }}"
                        fieldName="http_request_header_path"
                        for="http-request-header-path"
                    >
                        {{ l10nKeys.requestHeaderPathLabel | vtranslate }}
                    </label>
                    <input
                        clrInput
                        type="text"
                        id="http-request-header-path"
                        name="http-request-header-path"
                        [(ngModel)]="httpConfigItem.config.http_request_header_path"
                        objectType="{{ objectTypes.HealthMonitorHttp }}"
                        fieldName="http_request_header_path"
                        placeholder="{{ l10nKeys.headerPathPlaceHolder | vtranslate }}"
                    />
                </avi-input-container>
            </ng-container>
        </div>
    </div>
    <div
        class="full-modal-config__form-control-row"
        *ngIf="isHttp2Types"
    >
        <div class="full-modal-config__form-control">
            <avi-data-grid
                [config]="httpHeadersGridConfig"
                [rows]="httpHeaderGridRows"
            >
                <avi-data-grid_header>
                    <label
                        aviLabelWithTooltip
                        objectType="{{ objectTypes.HealthMonitorHttp }}"
                        fieldName="http_headers"
                    >
                        <h6>{{ l10nKeys.httpHeadersLabel | vtranslate }}</h6>
                    </label>
                </avi-data-grid_header>
                <avi-data-grid_actions>
                    <cds-button
                        (click)="addRow()"
                        size="sm"
                    >
                        {{ globalL10nKeys.addLabel | vtranslate }}
                    </cds-button>
                </avi-data-grid_actions>
                <ng-template
                    #gridHeaderTemplateRef
                    let-row
                    let-index="index"
                >
                    <avi-auto-complete
                        placeholder="{{ l10nKeys.headerPlaceholder | vtranslate }}"
                        [name]="'health-monitor-headers-' + index"
                        [(ngModel)]="row.header"
                        (ngModelChange)="handleRowChange(row, index)"
                    ></avi-auto-complete>
                </ng-template>
                <ng-template
                    #gridValueTemplateRef
                    let-row
                    let-index="index"
                >
                    <avi-auto-complete
                        placeholder="{{ globalL10nKeys.valuePlaceholder | vtranslate }}"
                        [name]="'health-monitor-values-' + index"
                        [(ngModel)]="row.value"
                        (ngModelChange)="handleRowChange(row, index)"
                    ></avi-auto-complete>
                </ng-template>
            </avi-data-grid>
        </div>
    </div>

    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.clientRequestBodyInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="http-request-body"
                objectType="{{ objectTypes.HealthMonitorHttp }}"
                fieldName="http_request_body"
                [(ngModel)]="httpConfigItem.config.http_request_body"
                placeholder="{{ l10nKeys.clientRequestBodyInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
    <clr-checkbox-container *ngIf="!isHttp2Types">
        <clr-checkbox-wrapper>
            <input
                clrCheckbox
                type="checkbox"
                name="exact-http-request"
                id="exact-http-request"
                [(ngModel)]="httpConfigItem.config.exact_http_request"
                [disabled]="disableUseExactRequestCheckbox"
            />
            <label
                aviLabelWithTooltip
                objectType="{{ objectTypes.HealthMonitorHttp }}"
                for="exact-http-request"
                fieldName="exact_http_request"
            >
                {{ l10nKeys.useExactRequestInputLabel | vtranslate }}
            </label>
        </clr-checkbox-wrapper>
    </clr-checkbox-container>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <h6>{{ l10nKeys.serverResponseDataInputLabel | vtranslate }}</h6>
            <newline-converted-textarea
                name="http-response"
                objectType="{{ objectTypes.HealthMonitorHttp }}"
                fieldName="http_response"
                [(ngModel)]="httpConfigItem.config.http_response"
                placeholder="{{ l10nKeys.serverResponseDataInputPlaceholder | vtranslate }}"
            ></newline-converted-textarea>
        </div>
    </div>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <label
                aviLabelWithTooltip
                objectType="{{ objectTypes.HealthMonitorHttp }}"
                fieldName="http_response_code"
                for="http-response-code"
                required
            >
                {{ globalL10nKeys.responseCodeLabel | vtranslate }}
            </label>
            <avi-enum-dropdown
                name="http-response-code"
                id="http-response-code"
                enum="HttpResponseCode"
                class="sel-http-status-code"
                [multiple]="true"
                [(ngModel)]="httpConfigItem.config.http_response_code"
                placeholder="{{ l10nKeys.responseCodeInputPlaceholder | vtranslate }}"
                required
            ></avi-enum-dropdown>
        </div>
    </div>

    <!-- HTTPS and HTTP2S type related fields -->
    <ng-container *ngIf="isHttpsType || isHttp2sType">
        <div class="full-modal-config__form-control-row">
            <h6>{{ globalL10nKeys.securityLabel | vtranslate }}</h6>
        </div>

        <div class="full-modal-config__form-control">
            <avi-fieldset [hideContent]="!sslAttributesEnabled">
                <avi-fieldset_header>
                    <avi-checkbox
                        name="enable-ssl-attributes"
                        [noMarginTop]="true"
                        [(ngModel)]="sslAttributesEnabled"
                        (ngModelChange)="handleEnableSslAttributesChange($event)"
                    >
                        {{ l10nKeys.enableSslAttributesLabel | vtranslate }}
                    </avi-checkbox>
                </avi-fieldset_header>

                <avi-fieldset_content>
                    <avi-input-container 
                        *ngIf="!(httpConfigItem.config.ssl_attributes?.config.use_pool_sni_server_name)" 
                        noMarginTop
                    >
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectTypes.HealthMonitorSSLAttributes }}"
                            fieldName="server_name"
                            for="server-name"
                        >
                            {{ globalL10nKeys.tlsSniServerNameLabel | vtranslate }}
                        </label>
                        <input
                            clrInput
                            id="server-name"
                            name="server-name"
                            [(ngModel)]="httpConfigItem.config.ssl_attributes?.config.server_name"
                            placeholder="{{ globalL10nKeys.tlsSniServerNameLabel | vtranslate }}"
                            regexPattern="hostname"
                        />
                    </avi-input-container>

                    <avi-input-container [noMarginTop]="httpConfigItem.config.ssl_attributes?.config.use_pool_sni_server_name">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectTypes.HealthMonitorSSLAttributes }}"
                            fieldName="ssl_profile_uuid"
                            for="ssl-profile-uuid"
                            [required]="sslAttributesEnabled"
                        >
                            {{ globalL10nKeys.sslProfileLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            id="ssl-profile-uuid"
                            name="ssl-profile-uuid"
                            [collection]="sslProfileCollection"
                            [(ngModel)]="httpConfigItem.config.ssl_attributes?.config.ssl_profile_ref"
                            placeholder="{{ globalL10nKeys.sslProfilePlaceholder | vtranslate }}"
                            [required]="sslAttributesEnabled"
                        ></avi-collection-dropdown>
                    </avi-input-container>

                    <avi-fieldset_header *ngIf="httpConfigItem.config.ssl_attributes?.config.ssl_profile_ref">
                        <avi-checkbox
                            objectType="{{ objectTypes.HealthMonitorHttp }}"
                            name="use-pool-sni-server-name"
                            id="use-pool-sni-server-name"
                            [noMarginTop]="true"
                            [(ngModel)]="httpConfigItem.config.ssl_attributes?.config.use_pool_sni_server_name"
                            (ngModelChange)="handleUsePoolSNIServerNameChange($event)"
                        >
                            {{ l10nKeys.usePoolSNIServerNameLabel | vtranslate }}
                        </avi-checkbox>
                    </avi-fieldset_header>

                    <div class="full-modal-config__form-control-row">
                        <div class="full-modal-config__form-control">
                            <label
                                aviLabelWithTooltip
                                objectType="{{ objectTypes.HealthMonitorSSLAttributes }}"
                                fieldName="pki_profile_uuid"
                                for="pki-profile-uuid"
                            >
                                {{ globalL10nKeys.pkiProfileLabel | vtranslate }}
                            </label>
                            <avi-collection-dropdown
                                id="pki-profile-uuid"
                                name="pki-profile-uuid"
                                [collection]="pkiProfileCollection"
                                [(ngModel)]="httpConfigItem.config.ssl_attributes?.config.pki_profile_ref"
                                placeholder="{{ globalL10nKeys.pkiProfilePlaceholder | vtranslate }}"
                            ></avi-collection-dropdown>
                        </div>
                    </div>

                    <div class="full-modal-config__form-control-row">
                        <div class="full-modal-config__form-control">
                            <label
                                aviLabelWithTooltip
                                objectType="{{ objectTypes.HealthMonitorSSLAttributes }}"
                                fieldName="ssl_key_and_certificate_uuid"
                                for="ssl-key-and-certificate-uuid"
                            >
                                {{ globalL10nKeys.sslKeyAndCertificateLabel | vtranslate }}
                            </label>
                            <avi-collection-dropdown
                                id="ssl-key-and-certificate-uuid"
                                name="ssl-key-and-certificate-uuid"
                                [collection]="certificateCollection"
                                [(ngModel)]="httpConfigItem.config.ssl_attributes?.config.ssl_key_and_certificate_ref"
                                placeholder="{{ globalL10nKeys.sslKeyAndCertificatePlaceholder | vtranslate }}"
                            ></avi-collection-dropdown>
                        </div>
                    </div>
                </avi-fieldset_content>
            </avi-fieldset>
        </div>
    </ng-container>
</div>
